module.exports = function (Utils) {
    'use strict';
    var segmentOptions = [
        'peaks',
        'id',
        'startTime',
        'endTime',
        'labelText',
        'color',
        'editable'
    ];
    function validateSegment(options, context) {
        if (!Utils.isValidTime(options.startTime)) {
            throw new TypeError('peaks.segments.' + context + ': startTime should be a valid number');
        }
        if (!Utils.isValidTime(options.endTime)) {
            throw new TypeError('peaks.segments.' + context + ': endTime should be a valid number');
        }
        if (options.startTime < 0) {
            throw new RangeError('peaks.segments.' + context + ': startTime should not be negative');
        }
        if (options.endTime < 0) {
            throw new RangeError('peaks.segments.' + context + ': endTime should not be negative');
        }
        if (options.endTime < options.startTime) {
            throw new RangeError('peaks.segments.' + context + ': endTime should not be less than startTime');
        }
        if (Utils.isNullOrUndefined(options.labelText)) {
            options.labelText = '';
        } else if (!Utils.isString(options.labelText)) {
            throw new TypeError('peaks.segments.' + context + ': labelText must be a string');
        }
        if (!Utils.isBoolean(options.editable)) {
            throw new TypeError('peaks.segments.' + context + ': editable must be true or false');
        }
        if (options.color && !Utils.isString(options.color) && !Utils.isLinearGradientColor(options.color)) {
            throw new TypeError('peaks.segments.' + context + ': color must be a string or a valid linear gradient object');
        }
    }
    function Segment(options) {
        validateSegment(options, 'add()');
        this._peaks = options.peaks;
        this._id = options.id;
        this._startTime = options.startTime;
        this._endTime = options.endTime;
        this._labelText = options.labelText;
        this._color = options.color;
        this._editable = options.editable;
        this._setUserData(options);
    }
    Segment.prototype._setUserData = function (options) {
        for (var key in options) {
            if (Utils.objectHasProperty(options, key) && segmentOptions.indexOf(key) === -1) {
                this[key] = options[key];
            }
        }
    };
    Object.defineProperties(Segment.prototype, {
        id: {
            enumerable: true,
            get: function () {
                return this._id;
            }
        },
        startTime: {
            enumerable: true,
            get: function () {
                return this._startTime;
            }
        },
        endTime: {
            enumerable: true,
            get: function () {
                return this._endTime;
            }
        },
        labelText: {
            enumerable: true,
            get: function () {
                return this._labelText;
            }
        },
        color: {
            enumerable: true,
            get: function () {
                return this._color;
            }
        },
        editable: {
            enumerable: true,
            get: function () {
                return this._editable;
            }
        }
    });
    Segment.prototype.update = function (options) {
        var opts = {
            startTime: this.startTime,
            endTime: this.endTime,
            labelText: this.labelText,
            color: this.color,
            editable: this.editable
        };
        Utils.extend(opts, options);
        validateSegment(opts, 'update()');
        this._startTime = opts.startTime;
        this._endTime = opts.endTime;
        this._labelText = opts.labelText;
        this._color = opts.color;
        this._editable = opts.editable;
        this._setUserData(options);
        this._peaks.emit('segments.update', this);
    };
    Segment.prototype.isVisible = function (startTime, endTime) {
        return this.startTime < endTime && startTime < this.endTime;
    };
    Segment.prototype._setStartTime = function (time) {
        this._startTime = time;
    };
    Segment.prototype._setEndTime = function (time) {
        this._endTime = time;
    };
    return Segment;
}(require('./utils'));